import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { TextField, Grid, InputLabel, TableFooter } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../ClaimBenefit/claimBenefit-styles.css";
import {
  searchPaymentAPI,
  inquiryAPI,
} from "./ClaimBenefitService/claimBenefitService";
import Skeleton from "react-loading-skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TablePagination } from "@material-ui/core";
import "moment/locale/th";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";
import OverwriteMomentBE from "../../util/OverwriteMomentBE";
import moment from "moment";
import { IconButton, InputAdornment } from "@material-ui/core";
import AlarmIcon from "@material-ui/icons/CalendarToday";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import { CustomInputText } from "../Component/CustomInputText";
import { CSVLink } from "react-csv";
import { Select, OutlinedInput, MenuItem } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import {
  searchRequest,
  updateTaken,
  updateCloseDate,
  getdetail,
  searchDataClaimBeneInfo,
  submitBenefit,
  cancelRequestSubmit,
} from "../RequestReport/RequestService/requestService";
import { Modal, Form, Col } from "react-bootstrap";
import { TableDetail } from "./component/TableDetail";
import successGif from "../../images/successGiff.gif";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService";
import warning from "../../images/warning.gif";

const ClaimBenefit = () => {
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {
            // backgroundColor: "#FFA500",
          },
        },
      },
    },
  });

  useEffect((date) => {}, []);

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const [payDate, setPayDate] = useState(null);
  const [policyNo, setPolicyNo] = useState("");
  const [rowPayment, setRowPayment] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [refNo, setRefNo] = useState("");
  const [LoadingContent, setLoadingContent] = useState(false);
  const [spinner, setSpinner] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentDate, setCurrentDate] = useState(moment());
  const [openTooltip, setOpenTooltip] = useState(false);

  const [policyNumber, setPolicyNumber] = useState("");
  const [insurerName, setInsurerName] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [requestStartDate, setRequestStartDate] = useState("");
  const [requestEndDate, setRequestEndDate] = useState("");
  const [closeStartDate, setCloseStartDate] = useState("");
  const [closeEndDate, setCloseEndDate] = useState("");
  const [dataTable, setDataTable] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showModalClose, setShowModalClose] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [selectedDetail, setSelectedDetail] = React.useState({});
  const [isDisabledTaken, setIsDisabledTaken] = useState(true);
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true);
  const [optionChangeType, setOptionChangeType] = useState([]);
  const processUserId = `${localStorage.getItem("first_name") || ""} ${
    localStorage.getItem("last_name") || ""
  }`;
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [showCancelSuccess, setShowCancelSuccess] = useState(false);

  const getConvertFormat = (date) => {
    const momentDate = moment(date);
    const formattedDate = momentDate.format("YYYY-MM-DD");
    setSelectedDate(formattedDate);
  };

  const clear = async () => {
    setPolicyNumber("");
    setInsurerName("");
    setType("");
    setStatus("");
    setRequestStartDate("");
    setRequestEndDate("");
    setCloseStartDate("");
    setCloseEndDate("");
    setSelectedRows([]);

    // เรียก API ด้วยค่าว่างโดยตรง แทนที่จะใช้ state ที่ยังไม่ได้ update
    setLoadingContent(true);
    setPage(0);
    const result = await searchDataClaimBeneInfo(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );
    setTimeout(() => {
      setDataTable(result.payload);
      setLoadingContent(false);
    }, 500);
  };

  function formatDate(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); /*+ 543*/
    return `${day}/${month}/${year}`;
  }

  function formatDate2(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); /*+ 543*/
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hour}:${minute}`;
  }

  function formatCurrency(amount) {
    return new Intl.NumberFormat("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getType = async () => {
    const result = await getParameterAPI(3);
    const payload = result.payload;
    console.log(result.payload);

    const changeType = payload.filter((item) =>
      [7, 8, 9, 10, 11].includes(Number(item.name))
    );

    setOptionChangeType(changeType);
  };

  useEffect(() => {
    getType();
    getRequest();
  }, []);

  const generateCsvData = (data) => {
    let data_csv = [];

    data.forEach((item) => {
      const detail =
        item.type === 10
          ? item.consents?.toString?.().trim?.().toUpperCase?.() === "N"
            ? "ไม่มีความประสงค์"
            : item.consents
            ? "มีความประสงค์"
            : "-"
          : "-";

      const data_row = {
        request_date: item.request_date
          ? moment(item.request_date).format("DD/MM/YYYY HH:mm")
          : "-",
        policy_number: `=""${item.policy_number}""`, // กัน Excel ตัดเลข
        insurer_name: item.insurer_name,
        subject: item.subject,
        status_by: item.status_by,
        close_date: item.close_date
          ? moment(item.close_date).format("DD/MM/YYYY")
          : "-",
        status: item.status,
        detail,
      };

      data_csv.push(data_row);
    });

    return data_csv;
  };

  const data_csv = generateCsvData(dataTable);

  const headers = [
    { label: "Request Date", key: "request_date" },
    { label: "Policy Number", key: "policy_number" },
    { label: "Insurer Name", key: "insurer_name" },
    { label: "Subject", key: "subject" },
    { label: "Status By", key: "status_by" },
    { label: "Close Date", key: "close_date" },
    { label: "Status", key: "status" },
    { label: "Detail", key: "detail" },
  ];

  const generateFilename = () => {
    const currentDate = moment().format("YYYYMMDDHHmm");
    return `REPORT_${currentDate}.csv`;
  };

  const getRequest = async () => {
    setLoadingContent(true);
    setPage(0);
    const result = await searchDataClaimBeneInfo(
      policyNumber,
      insurerName,
      requestStartDate ? moment(requestStartDate).format("YYYY-MM-DD") : "",
      requestEndDate ? moment(requestEndDate).format("YYYY-MM-DD") : "",
      closeStartDate ? moment(closeStartDate).format("YYYY-MM-DD") : "",
      closeEndDate ? moment(closeEndDate).format("YYYY-MM-DD") : "",
      type,
      status
    );
    setTimeout(() => {
      setDataTable(result.payload);
      setLoadingContent(false);
    }, 500);
  };

  const onSearch = () => {
    getRequest().then();
  };

  const toggleModalDetailOpen = (id_detail, type, policy_number, subject) => {
    setSelectedDetail({ id_detail, type, policy_number, subject }); // เก็บค่าที่เลือก
    setShowModalDetail(true); // เปิด Modal
  };

  const toggleModalDetailClose = () => {
    setShowModalDetail(false);
  };

  const handleUpdateTaken = async () => {
    if (selectedRows.length === 0) {
      alert("กรุณาเลือกรายการที่จะส่ง");
      return;
    }
    const body = selectedRows.map((id) => ({ id }));

    try {
      const response = await updateTaken(body); // ส่ง body ไปยังฟังก์ชัน updateTaken
      setSelectedRows([]);
      toggleModalOpen(); // รีเฟรชข้อมูลหลังจากการอัปเดตสำเร็จ
      setIsDisabledTaken(true);
      setIsDisabledSubmit(true);
      getRequest();
    } catch (error) {
      console.error("Error occurred while updating", error);
      alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    }
  };

  // const handleCheckboxChange = (event, id) => {
  //   let updatedSelectedRows;

  //   if (event.target.checked) {
  //     updatedSelectedRows = [...selectedRows, id];
  //   } else {
  //     updatedSelectedRows = selectedRows.filter((rowId) => rowId !== id);
  //   }

  //   setSelectedRows(updatedSelectedRows);

  //   // ปิดปุ่ม Taken ถ้าไม่มีแถวถูกเลือก
  //   setIsDisabledTaken(updatedSelectedRows.length === 0);

  //   // ตรวจสอบว่าใน updatedSelectedRows มีอย่างน้อย 1 แถวที่ status !== "Taken"
  //   const hasNonTaken = updatedSelectedRows.some((rowId) => {
  //     const row = dataTable.find((item) => item.id === rowId);
  //     return row?.status !== "Taken";
  //   });

  //   setIsDisabledSubmit(!hasNonTaken); // ถ้าไม่มีแถวที่ไม่ใช่ Taken → ปิดปุ่ม
  // };

  const handleCheckboxChange = (event, id) => {
    let updatedSelectedRows;

    if (event.target.checked) {
      updatedSelectedRows = [...selectedRows, id];
    } else {
      updatedSelectedRows = selectedRows.filter((rowId) => rowId !== id);
    }

    setSelectedRows(updatedSelectedRows);
    console.log(updatedSelectedRows);

    // ดึง row ล่าสุดที่เปลี่ยนสถานะ
    const currentRow = dataTable.find((item) => item.id === id);

    if (currentRow?.status === "Taken") {
      setIsDisabledTaken(true);
    } else {
      setIsDisabledTaken(updatedSelectedRows.length === 0);
    }

    const hasTaken = updatedSelectedRows.some((rowId) => {
      const row = dataTable.find((item) => item.id === rowId);
      return row?.status === "Taken";
    });

    setIsDisabledSubmit(!hasTaken);
  };

  const handleSubmit = () => {
    onSave();
    setShowModalClose(true);
  };

  const toggleModalOpen = () => {
    setShowModal(true);
  };

  const toggleModalClose = () => {
    setShowModal(false);
  };
  const toggleModalOpen2 = () => {
    setShowModalClose(true);
  };
  const toggleModalClose2 = () => {
    setShowModalClose(false);
  };
  const toggleModalCancel = () => {
    setShowModalCancel(false);
  };

  const handleCancel = () => {
    setShowModalCancel(true);
  };

  const toggleModalCancelSuccess = () => {
    setShowCancelSuccess(true);
  };

  const toggleCloselCancelSuccess = () => {
    setShowCancelSuccess(false);
  };

  const onSave = async () => {
    // ต้องมีแถวที่เลือก
    if (selectedRows.length === 0) {
      alert("กรุณาเลือกรายการที่จะส่ง");
      return;
    }

    const selectedItems = dataTable.filter((row) =>
      selectedRows.includes(row.id)
    );
    const hasTaken = selectedItems.some((row) => row.status === "Taken");
    if (!hasTaken) {
      alert("กรุณาเลือกรายการที่มีสถานะ Taken อย่างน้อย 1 รายการ");
      return;
    }
    console.log(selectedItems);
    console.log(processUserId);
    const payload = selectedItems.map((row) => ({
      id: row.customer_id,
      processUserId: processUserId,
      policyNo: row.policy_number,
      requestId: row.id,
      type: row.type,
    }));
    console.log(payload);
    try {
      setLoading(true);
      const result = await submitBenefit(payload);
      setLoading(false);
      setSelectedRows([]);
      setIsDisabledTaken(true);
      setIsDisabledSubmit(true);
      setShowModalClose(false);
      toggleModalOpen();
      getRequest();
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const cancelRequesBenefit = async () => {
    const result = await cancelRequestSubmit(selectedRows, processUserId);
    if (result.status) {
      setLoading(false);
      setSelectedRows([]);
      setIsDisabledTaken(true);
      setIsDisabledSubmit(true);
      setShowModalCancel(false);
      toggleModalCancelSuccess();
      getRequest();
    } else {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <div>
      <Header_Home />
      <Header title="การขอใช้สิทธิ" />
      {spinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </div>
      )}
      <div className="table-page-container footer-space">
        <div className="rounded-border bg-white p-2">
          {/* ปุ่มขวา */}
          <div
            id="export"
            className="text-align-right"
            style={{ marginTop: "20px" }}
          >
            <CSVLink
              data={data_csv}
              headers={headers}
              filename={generateFilename()}
              style={{ fontSize: 18 }}
              className="btn-fill-export p-2 bold"
            >
              Export File
            </CSVLink>
          </div>
          <br />
          <Grid
            container
            spacing={2}
            style={{ paddingInline: "32px", marginBottom: "15px" }}
          >
            {/* แถวที่ 1 */}
            <Grid item xs={12} md={3}>
              <CustomInputText
                id="input-policyNo"
                label="กรมธรรม์เลขที่"
                placeholder="กรมธรรม์เลขที่"
                value={policyNumber}
                onChange={(e) => setPolicyNumber(e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <CustomInputText
                id="input-fullname"
                label="ชื่อ นามสกุล"
                placeholder="ชื่อ-นามสกุล"
                value={insurerName}
                onChange={(e) => setInsurerName(e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Request Date
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={requestStartDate || null}
                  onChange={(value) => setRequestStartDate(value)}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={requestEndDate || null}
                  onChange={(value) => setRequestEndDate(value)}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            {/* แถวที่ 2 */}
            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Close Date
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={closeStartDate || null}
                  onChange={(value) => setCloseStartDate(value)}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={closeEndDate || null}
                  onChange={(value) => setCloseEndDate(value)}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Type
              </label>
              <Select
                input={<OutlinedInput />}
                style={{ borderRadius: "16px", height: "42px" }}
                value={type}
                onChange={(e) => setType(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">
                  <div style={{ color: "#999" }}>ประเภทการขอใช้สิทธิ</div>
                </MenuItem>
                {optionChangeType.map((option) => (
                  <MenuItem key={option.name} value={option.name}>
                    {option.description}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Status
              </label>
              <Select
                input={<OutlinedInput />}
                style={{ borderRadius: "16px", height: "42px" }}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">
                  <div style={{ color: "#999" }}>สถานะ</div>
                </MenuItem>
                <MenuItem value="New">New</MenuItem>
                <MenuItem value="Taken">Taken</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
                <MenuItem value="Canceled">Canceled</MenuItem>
              </Select>
            </Grid>
          </Grid>

          <br />
          <div className="App">
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={onSearch}
                className="btn-fill-orange  p-2 bold"
              >
                ค้นหา
              </button>
              <button onClick={clear} className="btn-fill-gray p-2 bold ml-2" style={{ marginLeft: '12px' }}>
                ล้าง
              </button>
            </section>
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // ✅ ให้ปุ่มอยู่ระดับเดียวกัน
                paddingInline: "10px",
                flexWrap: "wrap", // ✅ กัน overflow บนจอเล็ก
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* ปุ่มซ้าย */}
              <section
                className="filter-action-section"
                style={{ display: "flex", gap: "10px" }}
              >
                <button
                  style={{ fontSize: 18 }}
                  onClick={handleUpdateTaken}
                  className={
                    isDisabledTaken
                      ? "btn-fill-gray p-2 bold"
                      : "btn-fill-orange p-2 bold"
                  }
                  disabled={isDisabledTaken}
                >
                  Taken Owner
                </button>
                <button
                  style={{ fontSize: 18 }}
                  onClick={handleSubmit}
                  className={
                    isDisabledSubmit
                      ? "btn-fill-gray p-2 bold"
                      : "btn-fill-green p-2 bold"
                  }
                  disabled={isDisabledSubmit}
                >
                  Submit
                </button>
                <button
                  style={{ fontSize: 18 }}
                  onClick={handleCancel}
                  className={
                    isDisabledSubmit
                      ? "btn-fill-gray p-2 bold"
                      : "btn-fill-orange p-2 bold"
                  }
                  disabled={isDisabledSubmit}
                >
                  Cancel
                </button>
              </section>
            </div>

            <br />

            {LoadingContent ? (
              <div className="p-4">
                <div className="p-2">
                  <Skeleton className="h-70px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                </div>
              </div>
            ) : (
              <ThemeProvider theme={theme}>
                <TableContainer style={{ height: "auto" }} component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#e7e7e786" }}>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "3%" }}
                        >
                          Select
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "10%" }}
                        >
                          Policy Number
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "30%" }}
                        >
                          Insure Name
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "30%" }}
                        >
                          Type
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "20%" }}
                        >
                          Request Date
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "20%" }}
                        >
                          Close Date
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "10%" }}
                        >
                          Taken/Close by
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "20%" }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "10%" }}
                        >
                          Link
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "10%" }}
                        >
                          Detail
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {!(dataTable.length === 0) ? (
                        dataTable
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((item, idx) => {
                            const seq = idx + 1 + page * rowsPerPage;
                            return (
                              <TableRow key={idx}>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "3%" }}
                                >
                                  <input
                                    type="checkbox"
                                    value={item.id}
                                    id={item.id}
                                    name={item.id}
                                    onChange={(event) =>
                                      handleCheckboxChange(event, item.id)
                                    }
                                    className="checkbox-large margin-left-px mt-1"
                                    disabled={item.close_date ? true : false}
                                    checked={selectedRows.includes(item.id)}
                                  />
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  {item.policy_number}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "30%" }}
                                >
                                  {item.insurer_name}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "30%" }}
                                >
                                  {item.subject}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "20%" }}
                                >
                                  {item.request_date
                                    ? moment(item.request_date)
                                        .subtract(7, "hours")
                                        .format("DD/MM/YYYY HH:mm")
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "20%" }}
                                >
                                  {item.close_date
                                    ? moment(item.close_date).format(
                                        "DD/MM/YYYY"
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "20%" }}
                                >
                                  {item.status_by ? item.status_by : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  <span
                                    style={{
                                      color:
                                        item.status === "New"
                                          ? "#FA0E0E"
                                          : item.status === "Taken"
                                          ? "#FF5E43"
                                          : item.status === "Closed"
                                          ? "#12B71D"
                                          : "black",
                                    }}
                                  >
                                    {item.status}
                                  </span>
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  {item.link ? (
                                    <a
                                      href={item.link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Document
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </TableCell>

                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  {item.type === 10 ? (
                                    item.consents
                                      ?.toString?.()
                                      .trim?.()
                                      .toUpperCase() === "N" ? (
                                      "ไม่มีความประสงค์"
                                    ) : item.consents ? (
                                      "มีความประสงค์"
                                    ) : (
                                      "-"
                                    )
                                  ) : item.id_detail ? (
                                    <a
                                      className="link-event"
                                      onClick={() =>
                                        toggleModalDetailOpen(
                                          item.id_detail,
                                          item.type,
                                          item.policy_number,
                                          item.subject
                                        )
                                      }
                                    >
                                      Detail
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })
                      ) : (
                        <TableCell align="center" colSpan={12}>
                          <span className="font-new">ไม่พบข้อมูล</span>
                        </TableCell>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={dataTable.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </ThemeProvider>
            )}
          </div>
        </div>
        <Modal
          size="xl"
          show={showModalDetail}
          onHide={toggleModalDetailClose}
          centered
        >
          <Modal.Header closeButton>
            <h5 className="bold" style={{ color: "#ff5e43" }}>
              {selectedDetail.subject}
            </h5>
            {/* <Modal.Title>ตรวจสอบสำเร็จ</Modal.Title> */}
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#ff5e43",
            }}
          />
          <Modal.Body>
            <TableDetail
              id_detail={selectedDetail.id_detail}
              type={selectedDetail.type}
              policy_number={selectedDetail.policy_number}
            />

            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalDetailClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>
        <Modal
          size="xl"
          show={showModalDetail}
          onHide={toggleModalDetailClose}
          centered
        >
          <Modal.Header closeButton>
            <h5 className="bold" style={{ color: "#ff5e43" }}>
              {selectedDetail.subject}
            </h5>
            {/* <Modal.Title>ตรวจสอบสำเร็จ</Modal.Title> */}
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#ff5e43",
            }}
          />
          <Modal.Body>
            <TableDetail
              id_detail={selectedDetail.id_detail}
              type={selectedDetail.type}
              policy_number={selectedDetail.policy_number}
            />

            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalDetailClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>
        <Modal
          size="xl"
          show={showModalDetail}
          onHide={toggleModalDetailClose}
          centered
        >
          <Modal.Header closeButton>
            <h5 className="bold" style={{ color: "#ff5e43" }}>
              {selectedDetail.subject}
            </h5>
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#ff5e43",
            }}
          />
          <Modal.Body>
            <TableDetail
              id_detail={selectedDetail.id_detail}
              type={selectedDetail.type}
              policy_number={selectedDetail.policy_number}
            />

            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalDetailClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>

        <Modal show={showModal} onHide={toggleModalClose} centered>
          <Modal.Header closeButton>
            <h5 className="bold" style={{ color: "#ff5e43" }}>
              Taken
            </h5>
            {/* <Modal.Title>ตรวจสอบสำเร็จ</Modal.Title> */}
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#ff5e43",
            }}
          />
          <Modal.Body>
            <img
              src={successGif}
              alt={"confirmGif"}
              style={{
                height: "auto",
                marginLeft: "35%",
                width: "30%",
              }}
            />
            <li
              className="body-list-group"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                xl={12}
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <h3 className="bold">ระบบบันทึกข้อมูลเรียบร้อย</h3>
              </Col>
            </li>
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>

        <Modal show={showModalClose} onHide={toggleModalClose2} centered>
          <Modal.Header closeButton>
            {/* <h5 className="bold" style={{ color: "#ff5e43" }} >Taken</h5> */}
            {/* <Modal.Title>ตรวจสอบสำเร็จ</Modal.Title> */}
          </Modal.Header>
          {/* <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#ff5e43"
            }}
          /> */}
          <Modal.Body>
            <img
              src={successGif}
              alt={"confirmGif"}
              style={{
                height: "auto",
                marginLeft: "35%",
                width: "30%",
              }}
            />
            <li
              className="body-list-group"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                xl={12}
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <h3 className="bold">ระบบบันทึกข้อมูลเรียบร้อย</h3>
              </Col>
            </li>
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalClose2}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>

        <Modal show={showModalCancel} onHide={toggleModalCancel} centered>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <img
              src={warning}
              alt={"confirmGif"}
              style={{
                height: "auto",
                marginLeft: "35%",
                width: "30%",
              }}
            />
            <li
              className="body-list-group"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                xl={12}
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <h3 className="bold">ต้องการยกเลิกข้อมูลหรือไม่?</h3>
              </Col>
            </li>
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalCancel}
                className="btn-fill-gray  p-2 bold"
              >
                ยกเลิก
              </button>
              <button
                style={{ fontSize: 18 }}
                onClick={cancelRequesBenefit}
                className="btn-fill-orange  p-2 bold ml-2"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>

        <Modal
          show={showCancelSuccess}
          onHide={toggleCloselCancelSuccess}
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <img
              src={successGif}
              alt={"confirmGif"}
              style={{
                height: "auto",
                marginLeft: "35%",
                width: "30%",
              }}
            />
            <li
              className="body-list-group"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                xl={12}
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <h3 className="bold">ยกเลิกข้อมูลสำเร็จ</h3>
              </Col>
            </li>
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleCloselCancelSuccess}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default ClaimBenefit;
